import { Component, OnDestroy, OnInit } from '@angular/core';
import { Event, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

import { PendingService } from './core/services/base/pending.service';

@Component({
  selector: 'ltg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(
    private router: Router,
    private pendingService: PendingService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.initTranslations();
    this.initRouterEvents();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private initTranslations = () => {
    this.translate.setDefaultLang('es');
    this.translate.use('es');
  }

  private initRouterEvents = () => {
    this.subscription = this.router.events
      .filter(
        (event: Event) => event instanceof RouteConfigLoadStart || event instanceof RouteConfigLoadEnd
      )
      .subscribe((event: Event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.pendingService.addBlockingPending();
        } else if (event instanceof RouteConfigLoadEnd) {
          this.pendingService.removeBlockingPending();
        }
      });
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/app.component.ts